var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6672 7.63722C6.56033 8.77722 6.48533 10.7947 7.15845 11.6535C7.15845 11.6535 6.84158 9.43722 9.6822 6.6566C10.826 5.53722 11.0903 4.01472 10.691 2.87285C10.4641 2.22597 10.0497 1.6916 9.6897 1.31847C9.4797 1.0991 9.64095 0.737222 9.94658 0.750347C11.7953 0.832847 14.7916 1.3466 16.0647 4.5416C16.6235 5.9441 16.6647 7.39347 16.3985 8.86722C16.2297 9.80847 15.6297 11.901 16.9985 12.1578C17.9753 12.3416 18.4478 11.5653 18.6597 11.0066C18.7478 10.7741 19.0535 10.716 19.2185 10.9016C20.8685 12.7785 21.0091 14.9891 20.6678 16.8922C20.0078 20.571 16.2822 23.2485 12.581 23.2485C7.9572 23.2485 4.27658 20.6028 3.3222 15.8141C2.93783 13.881 3.13283 10.056 6.11408 7.35597C6.33533 7.15347 6.6972 7.33347 6.6672 7.63722Z",
    fill: "url(#paint0_radial_1155_2930)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2708 14.5155C12.5664 12.3217 13.3295 9.8186 13.7476 8.8211C13.8039 8.68985 13.6539 8.5661 13.5358 8.64673C12.8026 9.14548 11.3008 10.3192 10.6014 11.9711C9.6545 14.2042 9.722 15.2974 10.2826 16.6324C10.6201 17.4367 10.2283 17.6074 10.0314 17.6374C9.84013 17.6674 9.66388 17.5399 9.52325 17.4067C9.1187 17.0183 8.83041 16.5249 8.69075 15.9817C8.66075 15.8655 8.50888 15.8336 8.4395 15.9292C7.9145 16.6549 7.64263 17.8192 7.6295 18.6424C7.58825 21.1867 9.69013 23.2492 12.2326 23.2492C15.437 23.2492 17.7714 19.7055 15.9301 16.743C15.3958 15.8805 14.8933 15.3161 14.2708 14.5155Z",
    fill: "url(#paint1_radial_1155_2930)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1155_2930",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6652 23.3068) rotate(-179.751) scale(13.2352 21.7163)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#FF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#F44336"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1155_2930",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.4089 10.1352) rotate(90.5787) scale(13.8481 10.4217)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#FFF176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FFF27D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#FFF48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFF7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#FFF9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#FFF8BD",
    stopOpacity: 0.804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#FFF6AB",
    stopOpacity: 0.529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFF38D",
    stopOpacity: 0.209
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#FFF176",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.0552baf3925e2d2b762b75a4b42920de.svg";
export { ForwardRef as ReactComponent };